import type { GridSettings } from '~/components/Grid';

export enum ReportType {
    Clients = 'Clients',
    Forms = 'Forms',
    PackageGrants = 'PackageGrants',
    Events = 'Events',
    Classes = 'Classes',
    Payments = 'Payments',
    GiftCertificates = 'GiftCertificates',
    Invoices = 'Invoices',
}
export type Report = {
    id?: number;
    name: string;
    type: ReportType;
    settings: GridSettings & {
        templateSelected?: TemplateIndex;
    };
};

export enum TemplateIndex {
    BLANK_TEMPLATE = 0,
    LAST_MONTH_BOOKINGS = 1,
    REVENUE_PER_EVENT_TYPE = 2,
    ALL_CLIENTS = 3,
    ALL_CLASSES = 4,
    REVENUE = 5,
    ALL_INVOICES = 6,
}
